import { filterTickets } from "@/utils/loaders";
import {
  getInFlightEventStartPriceFetch,
  minPriceFromAvailableTickets,
  setCachedEventStartPrice,
  setInFlightEventStartPriceFetch,
} from "@/utils/event-start-price-cache";

const DEFAULT_FILTER_PARAMS = {
  tag_id: "all",
  tag_category_id: "all",
  tickets_number: "1",
  is_siblings: "0",
  per_page: "500",
} as const;

export async function fetchAndCacheAvailableEventPrice(
  eventId: string,
): Promise<number> {
  const existing = getInFlightEventStartPriceFetch(eventId);
  if (existing) {
    const price = await existing;
    return price ?? 0;
  }

  const promise = filterTickets({
    event_id: eventId,
    ...DEFAULT_FILTER_PARAMS,
  })
    .then((res) => {
      const price = minPriceFromAvailableTickets(res?.items ?? []);
      setCachedEventStartPrice(eventId, price);
      return price;
    })
    .catch(() => 0);

  setInFlightEventStartPriceFetch(eventId, promise);
  return promise;
}
